'use strict';

var cov_286uvkdfud = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\modules\\index.js',
      hash = 'f5c474895739493796143dee9388f29f8c7d8e19',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\modules\\index.js',
    statementMap: {
      '0': {
        start: {
          line: 19,
          column: 12
        },
        end: {
          line: 42,
          column: 1
        }
      },
      '1': {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 83
        }
      },
      '2': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 38
        }
      },
      '3': {
        start: {
          line: 35,
          column: 26
        },
        end: {
          line: 35,
          column: 53
        }
      },
      '4': {
        start: {
          line: 36,
          column: 29
        },
        end: {
          line: 36,
          column: 70
        }
      },
      '5': {
        start: {
          line: 37,
          column: 28
        },
        end: {
          line: 37,
          column: 68
        }
      },
      '6': {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 60
        }
      },
      '7': {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 60
        }
      },
      '8': {
        start: {
          line: 44,
          column: 0
        },
        end: {
          line: 44,
          column: 17
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
var app = (cov_286uvkdfud.s[0]++, {
  // Application Constructor
  initialize: function initialize() {
    cov_286uvkdfud.s[1]++;

    document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
  },


  // deviceready Event Handler
  //
  // Bind any cordova events here. Common events are:
  // 'pause', 'resume', etc.
  onDeviceReady: function onDeviceReady() {
    cov_286uvkdfud.s[2]++;

    this.receivedEvent('deviceready');
  },


  // Update DOM on a Received Event
  receivedEvent: function receivedEvent(id) {
    var parentElement = (cov_286uvkdfud.s[3]++, document.getElementById(id));
    var listeningElement = (cov_286uvkdfud.s[4]++, parentElement.querySelector('.listening'));
    var receivedElement = (cov_286uvkdfud.s[5]++, parentElement.querySelector('.received'));

    cov_286uvkdfud.s[6]++;
    listeningElement.setAttribute('style', 'display:none;');
    cov_286uvkdfud.s[7]++;
    receivedElement.setAttribute('style', 'display:block;');
  }
});

cov_286uvkdfud.s[8]++;
app.initialize();